export default {
  baseStyle: {
    field: {
      borderColor: 'whiteAlpha.100',
      '> option, > optgroup': {
        bg: 'gray.700',
      },
    },
  },
};
